import { render, staticRenderFns } from "./HomePageNavigationSectionsBlock.vue?vue&type=template&id=0b00aaf7&scoped=true&"
import script from "./HomePageNavigationSectionsBlock.vue?vue&type=script&lang=js&"
export * from "./HomePageNavigationSectionsBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomePageNavigationSectionsBlock.vue?vue&type=style&index=0&id=0b00aaf7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00aaf7",
  null
  
)

export default component.exports